export default __webpack_public_path__ + "static/media/higher_brand_marque_url.813d587b.svg";